/** Источник истины по ценам тарифа Профи (рубли). Имена тарифов — Базовый/Профи. */

/** Базовая цена Профи за первого участника; каждый следующий — −50%. Год = 9 месяцев (3 в подарок). */
export const PRO_BASE_PRICE = { monthly: 1200, yearly: 10800 } as const;

/** Скидка на каждого дополнительного участника команды. */
export const ADDITIONAL_SEAT_DISCOUNT = 0.5;

/** Полная стоимость 12 месяцев помесячно — база для расчёта годовой выгоды. */
export const MONTHS_PER_YEAR = 12;

export function formatRub(value: number): string {
  return `${new Intl.NumberFormat('ru-RU').format(value)} ₽`;
}
